type HIDEvent = {key: string, callback: Function, type: 'keydown' | 'keyup' | 'keypress' | 'mouseup' | 'wheel', repeat?: Boolean}

const HIDEvent = (key: string, callback: Function, type?: 'keydown' | 'keyup' | 'keypress' | 'mouseup' | 'wheel', repeat?: Boolean):HIDEvent => ({
	key: key, 
	callback: callback, 
	type: type ? type : key.indexOf('wheel') !== -1 ? 'wheel' : ['leftclick', 'middleclick', 'rightclick'].indexOf(key) !== -1 ? 'mouseup' : 'keypress',
	repeat: repeat || false
})

export default HIDEvent